export default ({ style, color = '#fff' }) => (
  <svg style={style} width="21.771" height="21.771" viewBox="0 0 21.771 21.771">
    <path
      d="M20.024,14.29a12.361,12.361,0,0,1-3.882-.618,1.774,1.774,0,0,0-1.726.364l-2.448,1.848A13.528,13.528,0,0,1,5.886,9.8L7.68,7.418a1.76,1.76,0,0,0,.433-1.783,12.38,12.38,0,0,1-.621-3.888A1.749,1.749,0,0,0,5.745,0h-4A1.749,1.749,0,0,0,0,1.747,20.047,20.047,0,0,0,20.024,21.771a1.749,1.749,0,0,0,1.747-1.747V16.037a1.749,1.749,0,0,0-1.747-1.747Z"
      transform="translate(0)"
      fill={color}
    />
  </svg>
)
